import { render, staticRenderFns } from "./pop-menu-button.vue?vue&type=template&id=3e3a709a&scoped=true&lang=pug&"
import script from "./pop-menu-button.vue?vue&type=script&lang=js&"
export * from "./pop-menu-button.vue?vue&type=script&lang=js&"
import style0 from "./pop-menu-button.vue?vue&type=style&index=0&id=3e3a709a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3a709a",
  null
  
)

export default component.exports